import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../node_modules/prop-types/index.js';
import React, { useMemo, useCallback } from 'react';
import { useFormControl } from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { DateTime } from 'luxon';
import usePickerInputValue from './usePickerInputValue.js';
import usePickerOpenState from './usePickerOpenState.js';
import { AdapterLuxon } from '../../node_modules/@mui/x-date-pickers/AdapterLuxon/AdapterLuxon.js';

var _excluded = ["value", "onChange", "size", "required", "error", "disabled", "slotProps", "minYear", "maxYear"];

var valueToYear = function valueToYear(v) {
  var year = Number(v);
  if (Number.isNaN(year)) return null;
  return DateTime.fromObject({
    year: year
  });
};

/**
 * Field for choosing a year
 */
var YearPicker = function YearPicker(_ref) {
  var _bounds$min, _bounds$max;

  var value = _ref.value,
      onChange = _ref.onChange,
      size = _ref.size,
      required = _ref.required,
      error = _ref.error,
      disabled = _ref.disabled,
      slotProps = _ref.slotProps,
      minYear = _ref.minYear,
      maxYear = _ref.maxYear,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var formControl = useFormControl();
  var pickerValue = useMemo(function () {
    if (!value) return null;
    return valueToYear(value);
  }, [value]);

  var _usePickerInputValue = usePickerInputValue(pickerValue),
      _usePickerInputValue2 = _slicedToArray(_usePickerInputValue, 2),
      inputValue = _usePickerInputValue2[0],
      setInputValue = _usePickerInputValue2[1];

  var _usePickerOpenState = usePickerOpenState(),
      open = _usePickerOpenState.open,
      onOpen = _usePickerOpenState.onOpen,
      onClose = _usePickerOpenState.onClose,
      popperProps = _usePickerOpenState.popperProps;

  var pickerChange = useCallback(function (v, _ref2) {
    var validationError = _ref2.validationError;
    setInputValue(v);
    if (!onChange) return;

    if (!v || !v.isValid || !!validationError) {
      onChange(null);
      return;
    }

    onChange(v.year);
  }, [onChange]);
  var bounds = useMemo(function () {
    return {
      min: typeof minYear === "number" || typeof minYear === "string" ? valueToYear(minYear) : minYear,
      max: typeof maxYear === "number" || typeof maxYear === "string" ? valueToYear(maxYear) : maxYear
    };
  }, [minYear, maxYear]);
  var textFieldProps = slotProps === null || slotProps === void 0 ? void 0 : slotProps.textField;
  return /*#__PURE__*/React.createElement(LocalizationProvider, {
    dateAdapter: AdapterLuxon
  }, /*#__PURE__*/React.createElement(DatePicker, _extends({}, otherProps, {
    views: ["year"],
    openTo: "year",
    value: inputValue,
    onChange: pickerChange,
    open: open,
    onOpen: onOpen,
    onClose: onClose,
    disabled: disabled !== null && disabled !== void 0 ? disabled : formControl === null || formControl === void 0 ? void 0 : formControl.disabled,
    slotProps: _objectSpread2(_objectSpread2({}, slotProps), {}, {
      popper: _objectSpread2(_objectSpread2({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.popper), popperProps),
      textField: _objectSpread2(_objectSpread2({}, textFieldProps), {}, {
        required: required !== null && required !== void 0 ? required : formControl === null || formControl === void 0 ? void 0 : formControl.required,
        error: error || formControl !== null && formControl !== void 0 && formControl.error ? true : undefined,
        // undefined allows internal validation errors to show
        size: size,
        onBlur: function onBlur(e) {
          if (inputValue && !pickerValue) setInputValue(null);
          if (textFieldProps !== null && textFieldProps !== void 0 && textFieldProps.onBlur) textFieldProps.onBlur(e);
        }
      })
    }),
    minDate: (_bounds$min = bounds.min) !== null && _bounds$min !== void 0 ? _bounds$min : undefined,
    maxDate: (_bounds$max = bounds.max) !== null && _bounds$max !== void 0 ? _bounds$max : undefined
  })));
};

YearPicker.propTypes = {
  value: propTypes.oneOfType([propTypes.number, propTypes.string, propTypes.oneOf([null])]),
  onChange: propTypes.func,
  required: propTypes.bool,
  error: propTypes.bool,
  minYear: propTypes.oneOfType([propTypes.any, propTypes.number, propTypes.string, propTypes.oneOf([null])]),
  maxYear: propTypes.oneOfType([propTypes.any, propTypes.number, propTypes.string, propTypes.oneOf([null])])
};
YearPicker.defaultProps = {
  format: "yyyy"
};
var YearPicker$1 = YearPicker;

export { YearPicker$1 as default };
